module.exports = __webpack_public_path__ + "static/media/Rounds-02.71d4de48.png";